import { render, staticRenderFns } from "./campaignContent.vue?vue&type=template&id=1ff4d9d0&scoped=true&"
import script from "./campaignContent.vue?vue&type=script&lang=js&"
export * from "./campaignContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4d9d0",
  null
  
)

export default component.exports